<template>
  <v-flex xs12 sm6 d-flex>
    <v-select
      :items="ordinations"
      label="Ordenação"
      v-model="ordination"
      item-text="title"
      item-value="business"
      return-object
      prepend-icon="swap_vert"
    ></v-select>
  </v-flex>
</template>
<script>
import { mapGetters } from "vuex";
import * as business from "@/helpers/business";

export default {
  name: "Ordination",
  computed: {
    ordination: {
      get() {
        return this.model;
      },
      set(value) {
        this.$store.dispatch("partners_payments/setOrdination", value);
        this.model;
      },
    },
    ...mapGetters({
      model: "partners_payments/filtersOrdination",
    }),
  },
  data: () => ({
    ordinations: [
      { title: "Mais antigos", business: business.PAYMENT_LOWER_ORDER },
      { title: "Mais recentes", business: business.PAYMENT_MOST_RECENT_ORDER },
      {
        title: "Valor mais baixo",
        business: business.PAYMENT_LOWER_VALUE_ORDER,
      },
      {
        title: "Valor mais alto",
        business: business.PAYMENT_HIGHEST_VALUE_ORDER,
      },
    ],
  }),
};
</script>
